import { GoogleStars } from '@belong/ui';

export const GoogleStarsSlice = () => (
  <div className="container flex flex-col items-center">
    <GoogleStars />
  </div>
);
